import { Link } from "react-router-dom";
import { useLanguage, tr } from "../i18n";
import { lp } from "./Navbar";
export default function Footer() {
  const {
    lang,
    t
  } = useLanguage();
  const f = t.footer;
  const cols = [{
    title: "ESAIA",
    links: [{
      label: t.nav.about,
      to: "/about"
    }, {
      label: f.standard01,
      to: "/standards"
    }, {
      label: f.contact,
      to: "/contact"
    }]
  }, {
    title: f.colServices,
    links: [{
      label: "ERI",
      to: "/eri"
    }, {
      label: f.individualCert,
      to: "/services"
    }, {
      label: f.groupCert,
      to: "/services"
    }, {
      label: f.recert,
      to: "/services"
    }]
  }, {
    title: f.colResources,
    links: [{
      label: t.nav.insights,
      to: "/insights"
    }, {
      label: "FAQ",
      to: "/faq"
    }, {
      label: t.nav.pricing,
      to: "/pricing"
    }]
  }, {
    title: f.colLegal,
    links: [{
      label: f.privacy,
      to: "/legal/privacy"
    }, {
      label: f.cookies,
      to: "/legal/cookies"
    }, {
      label: f.terms,
      to: "/legal/terms"
    }, {
      label: f.certDisclaimer,
      to: "/legal/certification-disclaimer"
    }]
  }];
  return <footer className="border-t border-esaia-line bg-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-3 lg:grid-cols-5">
          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <img src="/logo.png" alt={tr("ESAIA | Ethical Standards for Artificial Intelligence Assurance")} className="h-14 w-auto" data-testid="footer-brand-logo" />
            <p className="mt-4 text-sm leading-relaxed text-esaia-muted">{f.tagline}</p>
            <p className="mt-4 text-sm text-esaia-muted">{tr("Contact:")}{" "}
              <a href="mailto:info@esaia.org" className="font-medium text-esaia-blue hover:underline" data-testid="footer-email">{tr("info@esaia.org")}{" "}</a>
            </p>
            <p className="mt-1.5 text-sm text-esaia-muted" data-testid="footer-vat">{tr("BE1034.625.655")}{" "}</p>
          </div>
          {cols.map(c => <div key={c.title} className="lg:pl-10">
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-esaia-subtle">{c.title}</p>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l, i) => <li key={`${l.label}-${i}`}>
                    <Link to={lp(lang, l.to)} className="text-sm text-esaia-muted transition-colors hover:text-esaia-blue">
                      {l.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="mt-14 border-t border-esaia-line pt-8">
          <p className="max-w-4xl text-xs leading-relaxed text-esaia-subtle" data-testid="footer-disclaimer">
            {f.disclaimer}
          </p>
          <div className="mt-6 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
            <p className="text-xs text-esaia-subtle">
              © {new Date().getFullYear()}{" "}{tr("ESAIA | Ethical Standards for Artificial Intelligence Assurance.")}{" "}{f.rights}
            </p>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-esaia-subtle">{tr("Belgium")}</p>
          </div>
        </div>
      </div>
    </footer>;
}
